export const NOTIFICATION_API_BASEURLS = {
    dev: "https://notifications-d.my.trumpf.com",
    qa: "https://notifications-q.my.trumpf.com",
    prod: "https://notifications.my.trumpf.com"
};
export const NOTIFICATION_API_VERSION = "2.0";
export const NOTIFICATIONS_POLL_INTERVAL_DEFAULT = 10000;
export const NOTIFICATIONS_POLL_INTERVAL_MIN = 5000;
//# sourceMappingURL=constants.js.map
